if (!customElements.get('coming-soon-badge')) {
  customElements.define(
    'coming-soon-badge',
    class extends HTMLElement {
      connectedCallback() {
        const until = new Date(this.dataset.until).getTime();
        if (!Number.isNaN(until) && Date.now() < until) {
          this.hidden = false;
          const gallery = this.closest('.card-gallery');
          if (gallery) gallery.classList.add('card-gallery--coming-soon');
        } else {
          this.remove();
        }
      }
    }
  );
}